module.exports = __webpack_public_path__ + "static/seaanimalsorganicmuslin-ddd0559adbe1afb53ece8202a4682a26.jpeg";